let inFlightCancellableEnrichments = 0;

/**
 * Mark one cooperative enrichment as running.
 * Paired with {@link endCancellableEnrichment}.
 */
export const beginCancellableEnrichment = (): void => {
  inFlightCancellableEnrichments += 1;
};

/**
 * Mark one cooperative enrichment as finished (result, cancel, or error).
 */
export const endCancellableEnrichment = (): void => {
  inFlightCancellableEnrichments = Math.max(
    0,
    inFlightCancellableEnrichments - 1,
  );
};

/**
 * True while a cancellable enrichment has been posted and has not settled.
 * Keeps the save spinner up when an older PUT finishes during a newer enrich.
 */
export const hasInFlightCancellableEnrichment = (): boolean =>
  inFlightCancellableEnrichments > 0;
